import { number, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import {
    getMinMaxCols,
    getMinMaxGroupTilt,
    getMinMaxRows,
} from 'common/utils/helpers/systemsValues';

import {
    getCommonFieldsValidationSchema,
    getExtraFieldsValidationSchema,
} from './validateCommonFields';

export default (values) => {
    const {
        NUMBER_TYPE_TEXT,
        REQUIRED_TEXT,
        NO_DECIMAL_VALIDATION_TEXT,
        getMinValueText,
        getMaxValueText,
    } = getValidationTexts();

    const { system_uid, panel } = values;

    const rooftTab = {
        name: string().required(REQUIRED_TEXT).nullable(),
        safe_zone: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
    };

    const moduleTab = {
        azimuth: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .max(360, getMaxValueText(360))
            .nullable(),
        panel: object({
            height: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
            depth: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(30, getMinValueText(30))
                .max(40, getMinValueText(40))
                .nullable(),
            watts: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
            weight: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
            width: number()
                .typeError(NUMBER_TYPE_TEXT)
                .required(REQUIRED_TEXT)
                .min(0, getMinValueText(0))
                .nullable(),
        }),
        solar_module: string().when(
            'is_custom_module',
            ([is_custom_module], schema) => {
                if (is_custom_module) return schema.nullable();
                return schema.required(REQUIRED_TEXT).nullable();
            },
        ),
        solar_modules_number: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
    };

    const [minCols, maxCols] = getMinMaxCols(system_uid, panel.width);
    const [minRows, maxRows] = getMinMaxRows(system_uid);
    const [minTilt, maxTilt] = getMinMaxGroupTilt(system_uid);

    const groupTab = {
        col_spacing: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
        frame_col_spacing: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
        frame_cols_number: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(minCols, getMinValueText(minCols))
            .max(maxCols, getMaxValueText(maxCols))
            .integer(NO_DECIMAL_VALIDATION_TEXT)
            .nullable(),
        frame_row_spacing: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
        frame_rows_number: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(minRows, getMinValueText(minRows))
            .max(maxRows, getMaxValueText(maxRows))
            .integer(NO_DECIMAL_VALIDATION_TEXT)
            .nullable(),
        row_spacing: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(0, getMinValueText(0))
            .nullable(),
        tilt: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .min(minTilt, getMinValueText(minTilt))
            .max(maxTilt, getMaxValueText(maxTilt))
            .nullable(),
    };

    let otherValidations = {};

    const shape = {
        ...rooftTab,
        ...moduleTab,
        ...groupTab,
        ...getCommonFieldsValidationSchema(values),
        ...getExtraFieldsValidationSchema(values),
        ...otherValidations,
    };

    return object().shape(shape);
};
